var paragraph_default = {
  "fontElementMap": "_9XQje",
  "elementSpacing": "AFgAK",
  "text": "uAov7 AFgAK",
  "child": "WozF8"
};
export {
  paragraph_default as default
};
//# sourceMappingURL=paragraph-scss.js.map
